


















import { Component, Vue } from 'vue-property-decorator';

import { DateTime } from 'luxon';
import { curPref, Preferences } from '@/services/Preferences';

import VueError from '@/components/VueError.vue';
import NavBar from '@/components/NavBar.vue';
import NavBarRouter from '@/components/NavBarRouter.vue';
import NfreshProbes from '@/components/nfresh/NfreshProbes.vue';
import NfreshSubs from '@/components/nfresh/NfreshSubs.vue';

@Component({
  components: {
    VueError,
    NavBar,
    NavBarRouter,
    NfreshProbes,
    NfreshSubs
  },
})
export default class Nfresh extends Vue {

  curSection:'probes'|'subscriptions' = curPref.retrieve('v3-nfresh-cur-section', 'probes');
  error:string = '';

  routes = [
    {path: 'probes', label:'probes'},
    {path: 'subscriptions', label:'subscriptions'},
  ]
  
  // our model
  dateTime = DateTime;
  
  async mounted() {
    // nothing to do yet
  }

  navbarClickHandler(newSection:'probes'|'subscriptions') {
    curPref.store('v3-nfresh-cur-section', newSection);
    this.$router.push(`/applications/nfresh/${newSection}`)
    this.curSection = newSection;
  }

}
